import React, {createContext, useState} from 'react'
import PropTypes from 'prop-types'
import {BRAND_INFO as delonghiInfo} from './../../../brand-configuration/delonghi/brand'
import {BRAND_INFO as kenwoodInfo} from './../../../brand-configuration/kenwood/brand'

// Create a context with a default value
export const ThemeContext = createContext()

const ThemeProvider = ({children}) => {
    const [theme, setTheme] = useState(delonghiInfo)

    const toggleTheme = () => {
        setTheme((prevTheme) => {
            return prevTheme.key === 'delonghi' ? kenwoodInfo : delonghiInfo
        })
    }

    return <ThemeContext.Provider value={{theme, toggleTheme}}>{children}</ThemeContext.Provider>
}

export default ThemeProvider

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCustomTheme = () => {
    const context = React.useContext(ThemeContext)
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }
    return context
}
